import { FormElementType } from 'app/main/pages/clients/type';

export const FORMS_BASE_PATH = 'api/v2/forms';

export const FORMS_ROWS_PER_PAGE: number[] = [10, 25, 50];

export const QR_CODE_SIZE = 160;

export const LIST_QR_CODE_SIZE = 48;

export const QUESTION_ELEMENT_TYPES: FormElementType[] = [
  FormElementType.MULTIPLE_CHOICE,
  FormElementType.SINGLE_CHOICE,
  FormElementType.SHORT_TEXT,
  FormElementType.LONG_TEXT,
  FormElementType.SELECT,
  FormElementType.NUMBER,
  FormElementType.EMAIL,
  FormElementType.DATETIME,
  FormElementType.STAR_RATING,
];

export const LAYOUT_ELEMENT_TYPES: FormElementType[] = [FormElementType.IMAGE, FormElementType.PARAGRAPH];

export const TEMP_ELEMENT_PREFIX = 'tmp-';

export const generateTempElementId = (): string => `${TEMP_ELEMENT_PREFIX}${Math.random().toString(36).slice(2, 10)}`;
